<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isBuyer()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->
            
    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>My Wishlist</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<div class="col-sm-12">
	<div class="card card-primary" style="border-radius: 30px !important;" v-if="auction_lots!=''" v-for="lot in auction_lots" :key="lot.id">
		<div class="card-body row pt-10">
			<div class="col-sm-5 float-left">
				<h3>{{lot.lot_name}}</h3>
				<p>
					<b>Qoute Price:</b> {{lot.quote_price}}
				</p>
			</div>
			<div class="col-sm-3 mx-auto d-block row" align="center">
				<button class="btn btn-secondary" @click="lotDetails(lot.lot_id)" style="border-radius: 20px;"><b>Lot Details</b></button>
				<button class="btn btn-success" style="border-radius: 20px;" @click="joinBidding(lot)"  v-if="lot.status == 'under_auction'"><b>Join Bidding</b></button>
				<button class="btn btn-danger" @click="remove(lot.id, lot.auction_id)" style="border-radius: 20px;"><b> Remove</b></button>
			</div>
			<div class="col-sm-3" v-if="lot.status == 'under_auction' || lot.status == 'sold'">
				<h4>Highest bid so far: <br>Rs.<b class="gtext">{{lot.highest_bid_price}}</b></h4>
				<span class="badge badge-success" v-if="lot.bidder_id == user || lot.buyer_id == user ">Your Bid</span>
			</div>
    </div>
	</div>
  <div v-else>
			<h3>No Data</h3>
			<img src="../images/nodata.svg" alt="No data image">
		</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->
<br>
      <br>

    
<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isBuyer()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.');
            window.Echo.channel('auction.newbid')
        		.listen('NewBid', (e) => {
        				if(this.auction_lots.some(el => el.id == e.highest.auction_lot_id)){
		      				var index = this.auction_lots.findIndex((lot => lot.id == e.highest.auction_lot_id));
		      				this.auction_lots[index].highest_bid_price = e.highest.bid_price;
		     					this.auction_lots[index].buyer_id = e.highest.buyer_id;
		     				}
        		});
        },
        
        created(){
        	this.getLots();
        },
        
        data(){
        	return {
        		auction_lots: [],
        		user: this.$userId
        	}
        },
        
        methods: {
        	getLots(){
        		axios.post("/api/getMyWishlist", {auction_id: this.$route.params.id, user_id: user})
       				.then(response => {
       					this.auction_lots = response.data;
       				})
        	},
        	
        	lotDetails(id){
        		window.open('/home/buyer/lot-details/'+id)
        	},
        	
        	joinBidding(lot){
        		//console.log(lot.id);
        		this.$router.push('/home/buyer/lot-bidding/'+lot.id);
        	},
        	
        	remove(lot, auction){
        		axios.post("/api/removeWishlist", {auction_lot_id: lot, auction_id: auction, user_id: this.$userId})
        		.then(() => {
        			toast.fire({
      	      	icon: 'success',
              	title: 'Removed'
            	});
            	this.getLots();
        		});
        	}
        }
    }
</script>
